/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FeatureFlag extends models.FeatureFlagBase {
    constructor() {
        super();
        this.setDiscriminator("FeatureFlag");
    }

    getFixupPrototypeFunction() { return FeatureFlag.fixupPrototype; }

    static newInstance(model: Partial<FeatureFlag>): FeatureFlag {
        let obj = Object.assign(new FeatureFlag(), model);
        FeatureFlag.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FeatureFlag>): FeatureFlag {
        if (!model) return null;
        return FeatureFlag.newInstance(<FeatureFlag> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FeatureFlag) {
        if (!obj) return;

        models.FeatureFlag.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FeatureFlag): boolean {
        if (models.FeatureFlagBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, FeatureFlag.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * This is logical category defined for existing services specific feature flags
     */
    feature_category: models.FeatureCategory;

    /**
     * This is logical prefix defined for each logical feature categories
     */
    feature_category_prefix: models.FeatureCategoryPrefix;

    /**
     * The feature flag's type
     */
    flag_type: models.FeatureFlagType;

}
